module.exports = "https://coursera_assets.s3.amazonaws.com/images/d1567bd0fb536092dbaeac30f24a7379.svg";